import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { ANavLinks, NavItem, NavLinks, NavLinksBox } from "./NavBar.elements";
import {
  useMediaQuery,
  Stack
} from "@chakra-ui/react";
import { ArrowDownIcon } from "@chakra-ui/icons";

const StyledNavLinks = ({ onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSmallerThan992] = useMediaQuery("(max-width: 992px)");
  const [isGreaterThan1200] = useMediaQuery("(min-width: 1200px)");

  const adminMode = location?.pathname.startsWith("/administration");

  const [button, setButton] = useState(true);

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <Stack direction={{ base: "column", md: "row" }} spacing={"2px"}>
      <NavItem>
        <NavLink
          style={({ isActive }) => ({
            color: isActive ? "#5E3AEE" : "#FFF",
          })}
          to="/"
          onClick={onClose}
          cursor="pointer"
        >
          <NavLinks>Home</NavLinks>
        </NavLink>
      </NavItem>

      <NavItem>
        {" "}
        <NavLink
          style={({ isActive }) => ({
            color: isActive ? "#5E3AEE" : "#FFF",
          })}
          to="/about"
          onClick={onClose}
          cursor="pointer"
        >
          <NavLinks>About me</NavLinks>
        </NavLink>
      </NavItem>
      <NavItem>
        {" "}
        <NavLink
          style={({ isActive }) => ({
            color: isActive ? "#5E3AEE" : "#FFF",
          })}
          to="/projects"
          cursor="pointer"
          onClick={onClose}
        >
          <NavLinks>Projects</NavLinks>
        </NavLink>
      </NavItem>
      {/* <NavItem>
        <NavLinks
          to="/about"
          cursor="pointer"
          style={{
            color: "#FFF",
          }}
          onClick={onClose}
        >
          Testimonial
        </NavLinks>
      </NavItem> */}
      <NavItem>
        <NavLink
          to="/contact"
          cursor="pointer"
          style={({ isActive }) => ({
            color: isActive ? "#5E3AEE" : "#FFF",
          })}
          onClick={onClose}
        >
          <NavLinks>{"Contact"}</NavLinks>
        </NavLink>
      </NavItem>

      {/* {token && (
        <NavItemBtn>
          <NavBtnLink>
            {button ? (
              <StyledButton logout small onClick={auth.subscriberLogout}>
                LOGOUT
              </StyledButton>
            ) : (
              <StyledButton onClick={auth.subscriberLogout} big fontBig primary>
                LOGOUT
              </StyledButton>
            )}
          </NavBtnLink>
        </NavItemBtn>
      )} */}
    </Stack>
  );
};

export default StyledNavLinks;
